class CookieConsent extends HTMLElement {
  constructor() {
    super();

    this.cookie = this;

    if (this.getCookie("cookie-consent") === "") {
      this.cookie.style.display = "block";

      if (this.cookie.classList.contains("full-width")) {
        var cookieHeight = this.cookie.offsetHeight;

        if (cookieHeight > 0) {
          document.body.style.paddingBottom = cookieHeight + "px";
        }

        var w = window.innerWidth;

        window.addEventListener("resize", () => {
          if (window.innerWidth == w) {
            return;
          }

          w = window.innerWidth;

          var cookieHeight = this.cookie.offsetHeight;

          if (cookieHeight > 0) {
            document.body.style.paddingBottom = cookieHeight + "px";
          }
        });
      }
    } else {
      this.remove();
    }

    this.querySelector("[data-accept-cookie]").addEventListener(
      "click",
      this.setClosePopup.bind(this)
    );
  }

  setCookie(cname, cvalue) {
    document.cookie = cname + "=" + cvalue + ";path=/";
  }

  getCookie(cname) {
    const name = cname + "=";
    const ca = document.cookie.split(";");

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

  deleteCookie(name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  setClosePopup(event) {
    event.preventDefault();
    this.setCookie("cookie-consent", "closed");
    this.cookie.remove();
    if (this.cookie.classList.contains("full-width")) {
      document.body.style.paddingBottom = "0px";
    }

    // 调用 Google Consent Mode update
    if (typeof gtag === "function") {
      gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }

    // 调用 Shopify Consent API 通知平台用户已同意
    // 检查 Shopify.tracking_consent 对象和 grant 方法是否存在
    if (
      typeof Shopify !== "undefined" &&
      Shopify.tracking_consent &&
      typeof Shopify.tracking_consent.grant === "function"
    ) {
      // 根据您在 Shopify 设置中勾选的目的来决定这里授权哪些类别
      // 通常对应 'marketing', 'analytics', 'preferences'
      Shopify.tracking_consent.grant({
        marketing: true, // 对应市场营销
        analytics: true, // 对应分析
        preferences: true, // 对应偏好设置
        // 可能还需要其他类别，请根据您的具体需求和平台选项调整
      });
    }
  }
}

customElements.define("cookie-consent", CookieConsent);
